import { Box, Divider, Stack, Typography } from '@mui/material';
import React from 'react';
import { useIncPageTabsContext } from '../inc-page-tabs.hooks';

export const sectionOffset = 50;
export const sectionOffsetPx = `${sectionOffset}px`;

const IncPageSection = ({
  id,
  label,
  children,
  last,
  action = null,
  ...rest
}) => {
  const { registerSection } = useIncPageTabsContext();

  return (
    <Box
      sx={{
        pb: sectionOffsetPx,
        '::before': {
          display: 'block',
          content: '" "',
          marginTop: `-${sectionOffsetPx}`,
          height: sectionOffsetPx,
          visibility: 'hidden',
          pointerEvents: 'none',
        },
      }}
      id={id}
      ref={ref => registerSection(ref, last)}
      data-testid="IncPageSection"
      {...rest}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Typography variant="h2" data-testid="IncPageSection.Label" mb={0}>
          {label}
        </Typography>
        {action}
      </Stack>

      <Divider />
      {children}
    </Box>
  );
};

export default IncPageSection;
